import React from 'react';
import { FaDeleteLeft } from "react-icons/fa6";

export default function CustomNumpad({
    activeField,
    currentValue,
    costType,
    onChange,
    onCostTypeChange,
    onClose
}) {
    const handleKey = (key) => {
        if (key === 'clear') onChange('');
        else if (key === 'back') onChange(currentValue.slice(0, -1));
        else onChange(currentValue + key);
    };

    const isBGStars = costType === 'BGStars';

    return (
        <div className="custom-numpad stuck d-block">
            {activeField === 'Cost' && (
                <div className="cost-selector-row">
                    {['Mana', 'Coin', 'BGStars', 'ArmorCost', 'HealthCost', 'Runestone'].map(type => (
                        <img
                            key={type}
                            src={`/assets/numpad/icon_${type}.webp`}
                            className="cost_selector"
                            onClick={() => onCostTypeChange(type)}
                            alt={type}
                        />
                    ))}
                </div>
            )}

            {isBGStars && activeField === 'Cost' ? (
<div className="bgstars-grid">
  {[1, 2, 3, 4, 5, 6, 7].map(stars => (
    <button
      key={stars}
      type="button"
      className="numpad-btn bgstars-btn"
      onClick={() => onChange(stars.toString())}
    >
      <img
        src={`/assets/Card_Inhand_BannerAtlas_Minion_BGStars${stars}.webp`}
        alt={`${stars} stars`}
        className="bgstars-image"
      />
    </button>
  ))}
</div>
            ) : (
                <div className="numpad-grid">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
                        <button
                            key={num}
                            type="button"
                            className="numpad-btn"
                            onClick={() => handleKey(num.toString())}
                        >
                            {num}
                        </button>
                    ))}

                    <button
                        type="button"
                        className="numpad-btn text-danger"
                        onClick={() => handleKey('clear')}
                    >
                        C
                    </button>

                    <button
                        type="button"
                        className="numpad-btn"
                        onClick={() => handleKey('0')}
                    >
                        0
                    </button>

                    <button
                        type="button"
                        className="numpad-btn text-warning"
                        onClick={() => handleKey('back')}
                    >
                        <FaDeleteLeft />
                    </button>
                </div>
            )}

            {/* <div className="d-flex mt-3">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary flex-grow-1 fw-bold"
                    onClick={onClose}
                >
                    DONE
                </button>
            </div> */}
        </div>
    );
}